import { FC, useState, useMemo } from 'react';
import { Loader } from '@new/common/ui/Loader/Loader';
import { useGetNewlaneTutorialsQuery } from '@teachur/http-client';
import { TutorialsHeader } from '../components/TutorialsHeader/TutorialsHeader';
import { TutorialsSearchBar } from '../components/TutorialsSearchBar/TutorialsSearchBar';
import { TutorialGrid } from '../components/TutorialGrid/TutorialGrid';

export const TutorialsPage: FC = () => {
  const { data = [], isLoading } = useGetNewlaneTutorialsQuery();
  const [searchQuery, setSearchQuery] = useState('');

  const filteredTutorials = useMemo(() => {
    if (!searchQuery.trim()) {
      return data;
    }

    const query = searchQuery.toLowerCase();
    return data.filter(
      (tutorial) =>
        tutorial.name.toLowerCase().includes(query) ||
        tutorial.description?.toLowerCase().includes(query)
    );
  }, [data, searchQuery]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="flex flex-col gap-8 px-4 sm:px-6 lg:px-8 py-8">
      <TutorialsHeader count={data.length} />

      <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between w-full">
        <TutorialsSearchBar value={searchQuery} onChange={setSearchQuery} />
      </div>

      <TutorialGrid tutorials={filteredTutorials} searchQuery={searchQuery} />
    </div>
  );
};
